module.exports = __webpack_public_path__ + "img/xenoblade-chronicles.97c3f025.png";